'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _DataShareSearchForm = require('../DataShareSearchForm');

var _DataShareSearchForm2 = _interopRequireDefault(_DataShareSearchForm);

var _DisplayTable = require('../DisplayTable');

var _DisplayTable2 = _interopRequireDefault(_DisplayTable);

var _service = require('../../service');

var _utils = require('../../utils');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var renderLabel = function renderLabel(label, count) {
  if (!count) {
    return label;
  }
  return label + ' (' + count + ')';
};

var SearchTable = function (_Component) {
  _inherits(SearchTable, _Component);

  function SearchTable(props) {
    _classCallCheck(this, SearchTable);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onDataShareSearchFormReady = function (dataShareSearchFormInstance) {
      _this.dataShareSearchFormInstance = dataShareSearchFormInstance;
    };

    _this.onDisplayTableReady = function (displayFormInstance) {
      _this.displayFormInstance = displayFormInstance;
    };

    _this.fetchTableData = function (page, count) {
      var _this$state = _this.state,
          current = _this$state.current,
          pageSize = _this$state.pageSize;
      var _this$props = _this.props,
          params = _this$props.params,
          getRelaFormDataForParams = _this$props.getRelaFormDataForParams;

      var searchParam = _this.dataShareSearchFormInstance ? _this.dataShareSearchFormInstance.getData() : null;
      var formData = getRelaFormDataForParams();
      _this.setState({ showMask: true });
      return (0, _service.pageQueryShareData)(params, page || current, count || pageSize, formData, searchParam).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _this.setState({ showMask: false });
        var rowDatas = (res.list || []).map(function (item) {
          var rowData = {};
          try {
            rowData = JSON.parse(item.rowData);
          } catch (e) {}
          return _extends({}, item, rowData, _defineProperty({ rowData: rowData }, _utils.SELECT_KEY, item.checked));
        });
        _this.setState({
          pageData: {
            data: rowDatas,
            currentPage: res.current,
            totalCount: res.total
          },
          selectedRows: rowDatas.filter(function (rowData) {
            return rowData.checked;
          })
        });
        _this.updateRealSelectedRowsCount();
      }).catch(function (_ref) {
        var success = _ref.success,
            errorMsg = _ref.errorMsg;

        _this.setState({ showMask: false });
        _next.Message.error(errorMsg);
      });
    };

    _this.updateCheckedRows = function () {
      var rowKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if ((0, _lodash.isEmpty)(rowKeys)) {
        return;
      }
      var rowSelector = _this.props.rowSelector;

      _this.setState(function (_ref2) {
        var pageData = _ref2.pageData,
            selectedRows = _ref2.selectedRows;

        var rowDatas = [].concat(_toConsumableArray(pageData.data));
        rowDatas.forEach(function (rowData, index) {
          var checked = void 0;
          var tableChecked = void 0;
          if (rowSelector === 'radioSelector') {
            // 单选模式下清除其他
            checked = rowKeys.includes(rowData.rowKey);
            tableChecked = checked;
          } else {
            checked = rowData.checked || rowKeys.includes(rowData.rowKey);
            tableChecked = selectedRows.some(function (item) {
              return item.rowKey === rowData.rowKey;
            });
          }
          var newRowData = _extends({}, rowData, _defineProperty({ checked: checked }, _utils.SELECT_KEY, tableChecked || checked));
          rowDatas.splice(index, 1, newRowData);
        });
        var newRelectedRows = [].concat(_toConsumableArray(rowDatas)).filter(function (item) {
          return item[_utils.SELECT_KEY];
        });
        return {
          pageData: _extends({}, pageData, {
            data: rowDatas
          }),
          selectedRows: newRelectedRows,
          showSavingMask: false
        };
      }, function () {
        return _this.updateRealSelectedRowsCount();
      });
    };

    _this.updateRealSelectedRowsCount = function () {
      _this.setState(function (_ref3) {
        var selectedRows = _ref3.selectedRows;

        var realSelectedRowsCount = selectedRows && selectedRows.filter(function (item) {
          return !item.checked;
        }).length;
        return {
          realSelectedRowsCount: realSelectedRowsCount
        };
      });
    };

    _this.onTaskSuccess = function (data) {
      var onCancel = _this.props.onCancel;

      _this.setState({
        uploading: false,
        showSavingMask: false
      }, function () {
        onCancel();
      });
    };

    _this.onTaskProgress = function () {
      _this.setState({ uploading: true });
    };

    _this.onTaskError = function (e) {
      _next.Message.error(e.errorMsg || '全选失败');
      _this.setState({ uploading: false, showSavingMask: false });
    };

    _this.errorHandler = function (_ref4) {
      var success = _ref4.success,
          errorMsg = _ref4.errorMsg;

      _this.setState({ uploading: false, showSavingMask: false });
      _next.Message.error(errorMsg);
    };

    _this.onAddHandler = function (rowData) {
      var _this$props2 = _this.props,
          params = _this$props2.params,
          rowSelector = _this$props2.rowSelector;

      _this.setState({ showSavingMask: true });
      // 单选模式，选中时替换数据，先清除已经选中的数据
      if (rowSelector === 'radioSelector') {
        (0, _service.clearTable)({
          sequenceNo: params.sequenceNo,
          matterId: params.matterId,
          tablePropertyId: params.tablePropertyId
        }).then(function () {
          _this.saveAddRows([rowData]);
        }).catch(function (error) {
          return _this.errorHandler(error);
        });
      } else {
        _this.saveAddRows([rowData]);
      }
    };

    _this.onAddAll = function () {
      var _this$props3 = _this.props,
          params = _this$props3.params,
          getRelaFormDataForParams = _this$props3.getRelaFormDataForParams;

      var formData = getRelaFormDataForParams();
      var searchParam = _this.dataShareSearchFormInstance ? _this.dataShareSearchFormInstance.getData() : null;
      _this.setState({ showSavingMask: true });
      // 添加全部数据
      (0, _service.addAllFormDataShare)(params, formData, searchParam).then(function () {
        _this.onTaskProgress();
        (0, _service.addAllFormDataShareStatusQuery)(params, {
          onError: _this.onTaskError,
          onSuccess: _this.onTaskSuccess
        });
      }).catch(function (error) {
        _this.errorHandler(error);
      });
    };

    _this.onAddSelected = function () {
      var selectedRows = _this.state.selectedRows;

      _this.setState({ showSavingMask: true });
      // 过滤 checked = true 的数据
      var realSelectedRows = selectedRows.filter(function (item) {
        return !item.checked;
      });
      if ((0, _lodash.isEmpty)(realSelectedRows)) {
        _next.Message.notice('请至少选择一行数据新增');
      }
      _this.saveAddRows(realSelectedRows);
    };

    _this.saveAddRows = function (rows) {
      var _this$props4 = _this.props,
          params = _this$props4.params,
          rowSelector = _this$props4.rowSelector,
          getRelaFormDataForParams = _this$props4.getRelaFormDataForParams;

      var request = rows.map(function (item) {
        return {
          rowData: item.rowData
        };
      });
      var formData = getRelaFormDataForParams();
      var addCount = 'radioSelector' === rowSelector ? 0 : rows.length;
      (0, _service.saveRows)(_extends({}, params, { formData: formData, fromDataShare: true }), request).then(function (res) {
        _next.Message.notice('批量新增数据成功');
        _this.updateCheckedRows(rows.map(function (item) {
          return item.rowKey;
        }));
        _this.setState(function (_ref5) {
          var selectedCount = _ref5.selectedCount;

          return {
            selectedCount: selectedCount + addCount
          };
        });
      }).catch(function (error) {
        return _this.errorHandler(error);
      });
    };

    _this.onTabChange = function (tabKey) {
      if (tabKey === 'selected') {
        _this.displayFormInstance && _this.displayFormInstance.fetchTableData();
      } else if (tabKey === 'all') {
        _this.fetchTableData();
      }
    };

    _this.onDisplayTableQuery = function (selectedCount) {
      _this.setState({ selectedCount: selectedCount });
    };

    _this.dataShareSearchFormInstance = null;
    _this.displayFormInstance = null;
    _this.state = {
      selectedRows: [],
      pageData: {
        data: [],
        currentPage: 1,
        totalCount: 0
      },
      current: 1,
      pageSize: 10,
      showMask: false,
      showSavingMask: false,
      totalCount: 0,
      realSelectedRowsCount: 0,
      selectedCount: props.selectedCount
    };
    return _this;
  }

  SearchTable.prototype.componentDidMount = function componentDidMount() {
    var initCallback = this.props.initCallback;

    initCallback && initCallback(this);
    this.fetchTableData();
  };

  SearchTable.prototype.getColumns = function getColumns() {
    var _this2 = this;

    var columns = this.props.columns;

    var resultColumns = [].concat(_toConsumableArray(columns));
    resultColumns.push({
      dataIndex: 'action',
      title: '操作',
      width: '6rem',
      lock: 'right',
      cell: function cell(value, index, record) {
        return record.checked ? _react2.default.createElement(
          'span',
          null,
          '\u5DF2\u9009\u62E9'
        ) : _react2.default.createElement(
          _next.Button,
          { type: 'primary', text: true, onClick: function onClick() {
              return _this2.onAddHandler(record);
            } },
          '\u9009\u62E9'
        );
      }
    });
    return resultColumns.map(function (item) {
      return _react2.default.createElement(_next.Table.Column, item);
    });
  };

  SearchTable.prototype.renderBottomBar = function renderBottomBar() {
    var rowSelector = this.props.rowSelector;
    var _state = this.state,
        realSelectedRowsCount = _state.realSelectedRowsCount,
        showSavingMask = _state.showSavingMask,
        uploading = _state.uploading;

    return _react2.default.createElement(
      'div',
      { className: 'vc-big-table-search-table-bar' },
      rowSelector !== 'radioSelector' && _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(
          _next.Button,
          { onClick: this.onAddAll, loading: showSavingMask },
          '\u5168\u90E8\u6DFB\u52A0'
        ),
        uploading && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_next.Icon, { type: 'loading' }),
          '\xA0\u6B63\u5728\u4FDD\u5B58\uFF0C\u8BF7\u7A0D\u540E...\xA0'
        )
      ),
      rowSelector !== 'radioSelector' && _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(
          _next.Button,
          { onClick: this.onAddSelected, disabled: realSelectedRowsCount === 0, loading: showSavingMask },
          '\u6DFB\u52A0 (',
          realSelectedRowsCount,
          ')'
        ),
        _react2.default.createElement(
          'span',
          null,
          '\u8BF7\u70B9\u6B64\u6309\u94AE\u63D0\u4EA4\u5DF2\u7ECF\u9009\u4E2D\u7684\u6570\u636E'
        )
      )
    );
  };

  SearchTable.prototype.renderSearchForm = function renderSearchForm() {
    var _this3 = this;

    var searchFormProps = this.props.searchFormProps;

    return _react2.default.createElement(_DataShareSearchForm2.default, {
      dataShareSearchFields: searchFormProps && searchFormProps.dataShareSearchFields,
      searchHandler: function searchHandler() {
        // 每次重新执行搜索时，搜索结果默认为第一页
        _this3.setState({ current: 1 }, function () {
          _this3.fetchTableData(1);
        });
      },
      initCallback: this.onDataShareSearchFormReady
    });
  };

  SearchTable.prototype.renderTable = function renderTable() {
    var _this4 = this;

    var _props = this.props,
        rowSelector = _props.rowSelector,
        pageSizeList = _props.pageSizeList;
    var _state2 = this.state,
        showMask = _state2.showMask,
        pageSize = _state2.pageSize,
        pageData = _state2.pageData,
        selectedRows = _state2.selectedRows;

    var columns = this.getColumns();

    // 单选模式下不展示行 checkbox
    var rowSelection = rowSelector === 'radioSelector' ? undefined : {
      onSelect: function onSelect(selected, record, selectedRows) {
        _this4.setState({ selectedRows: selectedRows }, function () {
          _this4.updateRealSelectedRowsCount();
        });
      },
      onSelectAll: function onSelectAll(selected, selectedRows) {
        _this4.setState({ selectedRows: selectedRows }, function () {
          _this4.updateRealSelectedRowsCount();
        });
      },
      selectedRowKeys: selectedRows && selectedRows.map(function (item) {
        return item.rowKey;
      }),
      getProps: function getProps(record) {
        return {
          disabled: record.checked
        };
      }
    };

    var onPagerChange = function onPagerChange(current) {
      _this4.setState({ current: current }, function () {
        _this4.fetchTableData();
      });
    };

    var onPageSizeChange = function onPageSizeChange(pageSize) {
      _this4.setState({ current: 1, pageSize: pageSize }, function () {
        _this4.fetchTableData();
      });
    };

    var renderProps = {
      fixedHeader: true,
      maxBodyHeight: 400,
      dataSource: pageData.data,
      primaryKey: 'rowKey',
      rowSelection: rowSelection,
      loading: showMask,
      rowSelector: rowSelector
    };

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _next.Table,
        renderProps,
        columns
      ),
      _react2.default.createElement(_next.Pagination, {
        style: { marginTop: '10px', textAlign: 'right' },
        pageSizeSelector: 'filter',
        pageSizeList: pageSizeList && pageSizeList.length ? pageSizeList : [5, 10, 20],
        popupProps: { align: 'bl tl' },
        pageSizePosition: 'end',
        pageSize: pageSize,
        onChange: onPagerChange,
        current: pageData.currentPage,
        total: pageData.totalCount,
        onPageSizeChange: onPageSizeChange
      })
    );
  };

  SearchTable.prototype.render = function render() {
    var enableSearch = this.props.enableSearch;
    var _state3 = this.state,
        pageData = _state3.pageData,
        selectedCount = _state3.selectedCount;

    return _react2.default.createElement(
      _next.Tab,
      { shape: 'pure', onChange: this.onTabChange },
      _react2.default.createElement(
        _next.Tab.Item,
        { title: renderLabel('全部', pageData.totalCount), key: 'all' },
        _react2.default.createElement(
          'div',
          { className: 'vc-big-table-search-table' },
          enableSearch && this.renderSearchForm(),
          this.renderTable(),
          this.renderBottomBar()
        )
      ),
      _react2.default.createElement(
        _next.Tab.Item,
        { title: renderLabel('已选', selectedCount), key: 'selected' },
        _react2.default.createElement(_DisplayTable2.default, _extends({}, this.props, {
          onDisplayTableQuery: this.onDisplayTableQuery,
          initCallback: this.onDisplayTableReady
        }))
      )
    );
  };

  return SearchTable;
}(_react.Component);

exports.default = SearchTable;
module.exports = exports['default'];